import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import { AADHAR_VALIDATION, Email_Validation, ERROR_MSG, MOBILE_VALIDATION } from "../CommonUtils/contextVariables";
import * as bie from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import { failureAlert, successAlertRefresh } from "../CommonUtils/SweetAlerts";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { AiFillFileText } from "react-icons/ai";

export default function UniversityFacultyData() {

    const userId = sessionStorage.getItem("user_id");

    // **********validations********
    let navigate = useNavigate();
    const toSafeArray = (val) => {
        if (Array.isArray(val)) return val;
        if (val === null || val === undefined || val === "") return [];
        return [val];
    };
    const [makerApprovedData, setmakerApprovedData] = useState([]);
    function GetMakerData() {
        let url = `${config.url.FAC_URL}getCfmsFacultyData?cfmsId=${editData?.cfms_id}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setmakerApprovedData(res.data.data || []);
            } else {
                setmakerApprovedData([]);
            }
        });
    }
    const location = useLocation();
    const editData = location.state?.facultyData;

    const normalizeMakerData = (data) => {
        if (!data) return {};

        return {
            emp_full_name: data.fac_name,
            gender: data.gender,
            dob: data.date_of_birth,
            doj: data.date_of_join,
            university_type: data.unv_type,
            cfms_id: data.cfms_id,
            dept_id: data.dept_subject,
            natue_post_id: data.fac_type,
            caste_desc: data.caste,
            sub_caste_code: data.sub_caste,
            ews: data.ews,
            is_ph: data.is_ph,
            type_of_disability: data.type_of_disability,
            per_disability: data.per_disability,
            appoint_cat_id: data.appoint_cat,
            dist_id: data.local_dist,

            qual_id: data.qualification_appoint, // handle separately if needed

            mobile: data.contact,
            email: data.email_id,
            aadhar: data.aadhar_no,
            desig: data.designation,
            design_time_of_appointment: data.design_time_of_appointment,
        };
    };
    const finalData = (() => {
        if (editData?.is_edited && makerApprovedData?.length > 0) {
            return normalizeMakerData(makerApprovedData[0]); // ✅ mapped
        }
        return editData || {};
    })();

    const safeValue = (val) =>
        val === null || val === undefined || val === "null" ? "" : val;
    const validationSchema = Yup.object({
        facName: Yup.string().required(ERROR_MSG),
        gender: Yup.string().required(ERROR_MSG),
        dob: Yup.string().required(ERROR_MSG),

        doj: Yup.string().required(ERROR_MSG),
        aadharNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, "Invalid Aadhaar Number"),
        deptSubject: Yup.string().required(ERROR_MSG),
        facType: Yup.string().required(ERROR_MSG),
        designation: Yup.string().required(ERROR_MSG),
        caste: Yup.string().required(ERROR_MSG),


        qualAppointOther: Yup.string().when("qualificationAppoint", {
            is: (val) => val?.length === 1 && val?.[0] === 17,
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),

        qualLaterOther: Yup.string().when("qualificationLater", {
            is: (val) => val?.length === 1 && val?.[0] === 17,
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        ews: Yup.string().when("caste", {
            is: "OC",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        subCaste: Yup.string().required(ERROR_MSG),
        isPh: Yup.string().required(ERROR_MSG),
        unvType: Yup.string().required(ERROR_MSG),
        typeOfDisability: Yup.string().when("isPh", {
            is: "true",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        perDisability: Yup.string().when("isPh", {
            is: "true",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        // appointCat: Yup.string().required(ERROR_MSG),


        appointCat: Yup.string().when("facType", {
    is: (value) => Number(value) === 1, // Regular id
    then: (schema) => schema.required("Please select Appointed Category"),
    otherwise: (schema) => schema.notRequired(),
}),
        localDist: Yup.string().required(ERROR_MSG),
        designTimeOfAppointment: Yup.string().required(ERROR_MSG),
        qualificationAppoint: Yup.array()
            .of(Yup.number())
            .min(1, "Select at least one qualification")
            .required(ERROR_MSG),


        contact: Yup.string()
            .required(ERROR_MSG).nullable()
            .matches(MOBILE_VALIDATION, "Invalid mobile number"),
        emailId: Yup.string().required(ERROR_MSG).nullable().matches(Email_Validation, "Invalid Email Address"),
    });
    const facultyDetailsFormik = useFormik({

        initialValues: {
            facName: finalData ? safeValue(finalData?.emp_full_name) : "",
            gender: finalData ? safeValue(finalData?.gender) : "",
            dob: finalData?.dob ? finalData.dob.split("-").reverse().join("-") : "",
            doj: finalData?.doj ? finalData.doj.split("-").reverse().join("-") : "",
            unvType: finalData ? safeValue(finalData?.university_type) : "",
            cfmsId: finalData ? safeValue(finalData?.cfms_id) : "",
            // deptSubject: finalData ? safeValue(finalData?.dept_id) : "",
            deptSubject: finalData ? Number(finalData?.dept_id) : "",
            facType: finalData ? safeValue(finalData?.natue_post_id) : "",
            caste: finalData ? safeValue(finalData?.caste_desc) : "",
            subCaste: finalData ? safeValue(finalData?.sub_caste_code) : "",
            // ews: finalData ? safeValue(finalData?.ews) : "",
            ews: finalData ? String(finalData?.ews ?? "") : "",
            isPh: finalData ? safeValue(finalData?.is_ph) : "",
            typeOfDisability: finalData ? safeValue(finalData?.type_of_disability) : "",
            perDisability: finalData ? safeValue(finalData?.per_disability) : "",
            appointCat: finalData ? safeValue(finalData?.appoint_cat_id) : "",
            localDist: finalData ? safeValue(finalData?.dist_id) : "",
            qualAppointOther: "",
            qualLaterOther: "",
            qualificationAppoint: finalData
                ? toSafeArray(finalData.qual_id).map(Number)
                : [],
            qualificationLater: finalData
                ? toSafeArray(finalData.qual_id).map(Number)
                : [],

            contact: finalData ? safeValue(finalData?.mobile) : "",
            emailId: finalData ? safeValue(finalData?.email) : "",
            aadharNo: finalData ? safeValue(finalData?.aadhar) : "",
            designation: finalData ? safeValue(finalData?.desig) : "",
            designTimeOfAppointment: finalData ? safeValue(finalData?.design_time_of_appointment) : "",
            isNewFaculty: finalData ? false : true,
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            console.log("Submitted values:", val);

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveFacData`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc).then(() => {
                                navigate(-1);
                            });
                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    });

    // *******faculty type --get api*******
    const [facultyType, setFacultyType] = useState([]);
    function GetFacultyDetails() {
        let url = `${config.url.FAC_URL}getFacType`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setFacultyType(res.data.type || []);
            } else {
                setFacultyType([]);
            }
        });
    }



    // ✅ fallback
    const [appointedCategory, setAppointedCategory] = useState([]);
    function GetAppointedCategory() {
        let url = `${config.url.FAC_URL}getAppointedCatList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setAppointedCategory(res.data.AppointedCategory || []);
            } else {
                setAppointedCategory([]);
            }
        });
    }
    const [subCasteList, setSubCasteList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    function GetCaste() {
        let url = `${config.url.FAC_URL}geSubCasteList`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                const cleanedData = (res.data.subCaste || []).map(item => ({
                    ...item,
                    sub_caste_name: item.sub_caste_name?.trim()
                }));
                setSubCasteList(cleanedData);
                const uniqueCastes = [
                    ...new Set(cleanedData.map(item => item.caste_code))
                ];
                setCasteList(uniqueCastes);
            }
        });
    }



    const [distlist, setDistlist] = useState([]);

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDistricts`
        );
        setDistlist(res?.data?.scode === "01" ? res.data.getDistricts : []);
    };


    const [deptname, setDeptname] = useState([]);

    const getDeptList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDept`
        );
        setDeptname(res?.data?.scode === "01" ? res.data.data : []);
    };
    const [qualification, setQualification] = useState([]);

    const Qualificationlist = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getQualificationList`
        );
        setQualification(res?.data?.scode === "01" ? res.data.Qualification : []);
    };

    useEffect(() => {
        GetMakerData();
        GetFacultyDetails();
        GetCaste();
        Qualificationlist();
        GetAppointedCategory();
        fetchDistList();
        getDeptList();
    }, []);
    const filteredSubCaste = subCasteList.filter(
        item => item.caste_code === facultyDetailsFormik.values.caste
    );
    const showLecturer = !editData && !makerApprovedData?.[0];

    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">

                    <div className='fac-topbar'>

                        <div className='fac-detnew'>
                            <h5 className='mb-0'>{editData ? "Edit Faculty Details" : "Add New Faculty"}</h5>
                        </div>
                        <button
                            className="newfacbtn btn btn-primary d-flex align-items-center"
                            onClick={() => navigate("/FacultyReport")}
                            style={{ gap: "8px" }}
                        >
                            <AiFillFileText size={20} />
                            Go to Faculty Details Report
                        </button>


                    </div>

                    <FormikProvider value={facultyDetailsFormik}>
                        <Form className="form_adjust" onSubmit={facultyDetailsFormik?.handleSubmit} onChange={facultyDetailsFormik?.handleChange}>
                            {/* ================= PERSONAL DETAILS ================= */}
                            <h5 className="mb-3 innerheader-new"><span>Personal </span>Details </h5>
                            <bie.Row>
                                {/* Faculty Name */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Faculty Name</label>
                                    <Field
                                        name="facName"
                                        className="form-control"
                                        maxLength={60}
                                        onKeyPress={allowAlphabetAndSpacesOnly}
                                    />
                                    <ErrorMessage name="facName" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Gender */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Gender</label>
                                    <Field as="select" name="gender" className="form-control">
                                        <option value="">---Select---</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </Field>
                                    <ErrorMessage name="gender" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Date of Birth */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Date of Birth</label>
                                    <Field type="date" name="dob" className="form-control" max="2002-12-31" />
                                    <ErrorMessage name="dob" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Aadhaar No</label>
                                    <Field
                                        name="aadharNo"
                                        className="form-control"
                                        maxLength={12}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="aadharNo" component="div" className="text-danger" />
                                </bie.Col>


                                {/* WhatsApp */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Whatsapp Number</label>
                                    <Field
                                        name="contact"
                                        className="form-control"
                                        onKeyPress={allowNumbersOnly}
                                        maxLength={10}
                                    />
                                    <ErrorMessage name="contact" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Email */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Email ID</label>
                                    <Field type="email" name="emailId" className="form-control" />
                                    <ErrorMessage name="emailId" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Local District */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Local District</label>
                                    <Field as="select" name="localDist" className="form-control form-control-md">
                                        <option value="">---select---</option>
                                        {distlist?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="localDist" component="div" className="text-danger" />
                                </bie.Col>




                            </bie.Row>
                            <h5 className="mt-3 mb-3 innerheader-new"><span>Professional</span> Details</h5>
                            <bie.Row>


                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Type of University</label>
                                    <Field as="select" name="unvType" className="form-control" >


                                        <option value="">--Select--</option>
                                        <option value="Technical University"> Technical University</option>
                                        <option value="Multi-Discipline University"> Multi-Discipline University</option>

                                    </Field>
                                    <ErrorMessage name="unvType" component="div" className="text-danger" />
                                </bie.Col>
                                {/* Date of Joining */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Date of Joining in the university</label>
                                    <Field type="date" name="doj" className="form-control" min={
                                        facultyDetailsFormik?.values?.dob
                                            ? moment(facultyDetailsFormik?.values.dob).add(18, "years").format("YYYY-MM-DD")
                                            : ""
                                    }
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                    <ErrorMessage name="doj" component="div" className="text-danger" />
                                </bie.Col>

                                {/* CFMS ID */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>CFMS ID/Employee ID</label>
                                    <Field name="cfmsId" className="form-control" onKeyPress={allowNumbersOnly} maxLength={13} />
                                </bie.Col>


                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label> Current Designation</label>
                                    <Field as="select" name="designation" className="form-control">
                                        <option value="">---Select---</option>
                                        {showLecturer && <option value="Lecturer">Lecturer</option>}
                                        <option value="Professor">Professor</option>
                                        <option value="Associate Professor">Associate Professor</option>

                                        <option value="Assistant Professor">Assistant Professor</option>
                                        <option value="Academic Consultant">Academic Consultant</option>
                                        <option value="Teaching Assistant">Teaching Assistant</option>


                                        {userId === "U-0632_maker" &&
                                            <option value="RGUKT Mentor">RGUKT Mentor</option>

                                        }


                                    </Field>
                                    <ErrorMessage name="designation" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Designation at the time of Appointment</label>
                                    <Field as="select" name="designTimeOfAppointment" className="form-control">
                                        <option value="">---Select---</option>

                                        {showLecturer && <option value="Lecturer">Lecturer</option>}

                                        <option value="Professor">Professor</option>
                                        <option value="Associate Professor">Associate Professor</option>

                                        <option value="Assistant Professor">Assistant Professor</option>
                                        <option value="Academic Consultant">Academic Consultant</option>
                                        <option value="Teaching Assistant">Teaching Assistant</option>

                                        {userId === "U-0632_maker" &&
                                            <option value="RGUKT Mentor">RGUKT Mentor</option>

                                        }

                                    </Field>
                                    <ErrorMessage name="designTimeOfAppointment" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Department / Subject</label>

                                    <Select
                                        name="deptSubject"
                                        options={deptname?.map((item) => ({
                                            value: item.dept_id,
                                            label: item.dept_name,
                                        }))}

                                        value={
                                            deptname
                                                ?.map((item) => ({
                                                    value: item.dept_id,
                                                    label: item.dept_name,
                                                }))
                                                .find(
                                                    (option) =>
                                                        option.value === facultyDetailsFormik.values.deptSubject
                                                ) || null
                                        }

                                        onChange={(selectedOption) => {
                                            facultyDetailsFormik.setFieldValue(
                                                "deptSubject",
                                                selectedOption ? selectedOption.value : ""
                                            );
                                        }}

                                        placeholder="--Select Department--"
                                        isSearchable
                                        classNamePrefix="react-select"
                                    />

                                    <ErrorMessage
                                        name="deptSubject"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>



                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Type of Faculty</label>

                                    <Field as="select" name="facType" className="form-control">
                                        <option value="">--Select--</option>
                                        {facultyType?.filter((p) => {
                                                if (!editData && p.fac_type_name === "Regular") {
                                                    return false;
                                                }
                                                if (
                                                    userId !== "U-0632_maker" &&
                                                    (p.fac_type_id === 6)
                                                ) {
                                                    return false;
                                                }

                                                return true;
                                            })
                                            .map((p) => (
                                                <option key={p.fac_type_id} value={p.fac_type_id}>
                                                    {p.fac_type_name}
                                                </option>
                                            ))}

                                    </Field>

                                    <ErrorMessage name="facType" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Appointed Category</label>
                                    <select
                                        name="appointCat"
                                        className="form-control"
                                        value={facultyDetailsFormik.values.appointCat}
                                        onChange={facultyDetailsFormik.handleChange}
                                    >
                                        <option value="">--Select Appointed Category--</option>
                                        {appointedCategory?.map((app, index) => (
                                            <option key={index} value={app?.appoint_cat_id}>
                                                {app?.appoint_cat_name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name="appointCat" component="div" className="text-danger" />
                                </bie.Col>



                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Qualifications at the time of appointment</label>

                                    <Select
                                        name="qualificationAppoint"
                                        options={qualification?.map((item) => ({
                                            value: item.qual_id,
                                            label: item.qual_name,
                                        }))}

                                        isMulti

                                        value={
                                            qualification
                                                ?.map((item) => ({
                                                    value: item.qual_id,
                                                    label: item.qual_name,
                                                }))
                                                .filter((option) =>
                                                    // facultyDetailsFormik.values.qualificationAppoint?.includes(option.value)
                                                    Array.isArray(facultyDetailsFormik.values.qualificationAppoint) &&
                                                    facultyDetailsFormik.values.qualificationAppoint.includes(option.value)
                                                ) || []
                                        }


                                        onChange={(selectedOptions) => {
                                            const values = selectedOptions ? selectedOptions.map(o => o.value) : [];

                                            facultyDetailsFormik.setFieldValue("qualificationAppoint", values);

                                            if (!(values.length === 1 && values[0] === 17)) {
                                                facultyDetailsFormik.setFieldValue("qualAppointOther", "");
                                            }
                                        }}
                                        onBlur={() =>
                                            facultyDetailsFormik.setFieldTouched("qualificationAppoint", true)
                                        }

                                        placeholder="--Select Qualification--"
                                        isSearchable
                                        isClearable
                                        classNamePrefix="react-select"
                                    />

                                    <ErrorMessage name="qualificationAppoint" component="div" className="text-danger" />
                                </bie.Col>



                                {facultyDetailsFormik?.values?.qualificationAppoint?.length === 1 &&
                                    facultyDetailsFormik?.values?.qualificationAppoint?.[0] === 17 && (<>

                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                            <label>Other Qualifications at the time of Appointment</label>
                                            <Field type="text" name="qualAppointOther" className="form-control" maxLength={30} />
                                            <ErrorMessage name="qualAppointOther" component="div" className="text-danger" />
                                        </bie.Col>
                                    </>)}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Qualification Acquired Later</label>

                                    <Select
                                        name="qualificationLater"
                                        options={qualification?.map((item) => ({
                                            value: item.qual_id,
                                            label: item.qual_name,
                                        }))}

                                        isMulti

                                        value={
                                            qualification
                                                ?.map((item) => ({
                                                    value: item.qual_id,
                                                    label: item.qual_name,
                                                }))
                                                .filter((option) =>
                                                    facultyDetailsFormik.values.qualificationLater?.includes(option.value)
                                                ) || []
                                        }

                                        onChange={(selectedOptions) => {
                                            const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];

                                            facultyDetailsFormik.setFieldValue("qualificationLater", values);

                                            if (!(values.length === 1 && values[0] === 17)) {
                                                facultyDetailsFormik.setFieldValue("qualLaterOther", "");
                                            }
                                        }}

                                        onBlur={() =>
                                            facultyDetailsFormik.setFieldTouched("qualificationLater", true)
                                        }

                                        placeholder="--Select Qualification--"
                                        isSearchable
                                        isClearable
                                        classNamePrefix="react-select"
                                    />


                                </bie.Col>

                                {facultyDetailsFormik?.values?.qualificationLater?.length === 1 &&
                                    facultyDetailsFormik?.values?.qualificationLater?.[0] === 17 && (<>

                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                            <label>Other Qualification Acquired Later</label>
                                            <Field type="text" name="qualLaterOther" className="form-control" maxLength={30} />
                                            <ErrorMessage name="qualLaterOther" component="div" className="text-danger" />
                                        </bie.Col>
                                    </>)}

                            </bie.Row>

                            {/* ================= CASTE DETAILS ================= */}
                            <h5 className="mt-3 innerheader-new"><span>Caste</span> Details</h5>
                            <bie.Row>
                                {/* Caste Category */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Caste Category</label>
                                    <select
                                        name="caste"
                                        className="form-control"
                                        value={facultyDetailsFormik.values.caste}
                                        onChange={(e) => {
                                            facultyDetailsFormik.handleChange(e);
                                            facultyDetailsFormik.setFieldValue("subCaste", "");
                                            facultyDetailsFormik.setFieldValue("ews", "");
                                        }}
                                    >
                                        <option value="">--Select Caste--</option>
                                        {casteList?.map((casteCode, index) => (
                                            <option key={index} value={casteCode}>
                                                {casteCode}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name="caste" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Sub Caste */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Sub Caste</label>
                                    <Select
                                        name="subCaste"
                                        options={filteredSubCaste.map((item) => ({
                                            value: item.sub_caste_code,
                                            label: item.sub_caste_name,
                                        }))}
                                        value={
                                            filteredSubCaste
                                                .map((item) => ({ value: item.sub_caste_code, label: item.sub_caste_name }))
                                                .find((option) => option.value === facultyDetailsFormik.values.subCaste) || null
                                        }
                                        onChange={(selectedOption) => {
                                            facultyDetailsFormik.setFieldValue(
                                                "subCaste",
                                                selectedOption ? selectedOption.value : ""
                                            );
                                        }}
                                        placeholder="--Select Sub Caste--"
                                        isSearchable
                                        classNamePrefix="react-select"
                                    />
                                    <ErrorMessage name="subCaste" component="div" className="text-danger" />
                                </bie.Col>

                                {/* EWS */}
                                {facultyDetailsFormik.values.caste === "OC" && (
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                        <label>Whether belongs to EWS category?</label>
                                        <div className="form-border">
                                            <Field type="radio" value="true" name="ews" className="form-sub me-1" /> Yes &nbsp;&nbsp;
                                            <Field type="radio" value="false" name="ews" className="form- me-1" /> No
                                        </div>
                                        <ErrorMessage name="ews" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                            </bie.Row>

                            {/* ================= PH DETAILS ================= */}
                            <h5 className="mt-3 innerheader-new"><span>PH</span> Details</h5>
                            <bie.Row>
                                {/* Physically Challenged */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Physically Challenged</label>
                                    <Field
                                        as="select"
                                        name="isPh"
                                        className="form-control"
                                        onChange={(e) => {
                                            facultyDetailsFormik.setFieldValue("typeOfDisability", '');
                                            facultyDetailsFormik.setFieldValue("perDisability", '');
                                            // facultyDetailsFormik.setFieldValue("isScribe", '');
                                        }}
                                    >
                                        <option value="">--Select--</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </Field>
                                    <ErrorMessage name="isPh" component="div" className="text-danger" />
                                </bie.Col>

                                {facultyDetailsFormik.values.isPh === "true" && (<>
                                    {/* <div className="ph-section-wrapper"> */}
                                    {/* <bie.Row className="g-3"> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-3">
                                        <label>Type of Disability</label>
                                        <Field as="select" name="typeOfDisability" className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="MENTAL DISABILITY / MULTIPLE DISABILITY(MD)">MENTAL / MULTIPLE DISABILITY</option>
                                            <option value="ORTHOPEDICALLY HANDICAPPED(OH)">ORTHOPEDICALLY HANDICAPPED</option>
                                            <option value="HEARING IMPAIRED(HI)">HEARING IMPAIRED</option>
                                            <option value="VISUALLY IMPAIRED(VI)">VISUALLY IMPAIRED</option>
                                        </Field>
                                        <ErrorMessage name="typeOfDisability" component="div" className="text-danger" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-3">
                                        <label>Percentage of Disability</label>
                                        <Field as="select" name="perDisability" className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="40-45">40-45 %</option>
                                            <option value="46-50">46-50 %</option>
                                            <option value="51-55">51-55 %</option>
                                            <option value="56-60">56-60 %</option>
                                            <option value="61-65">61-65 %</option>
                                            <option value="66-70">66-70 %</option>
                                            <option value="Above 70">Above 70 %</option>
                                        </Field>
                                        <ErrorMessage name="perDisability" component="div" className="text-danger" />
                                    </bie.Col>



                                </>)}
                            </bie.Row>
                            <div className="d-flex justify-content-end mt-3">
                                {makerApprovedData[0]?.is_checker_approved === true ? (
                                    <span className="text-success fw-bold">
                                        ✅ Already Submitted
                                    </span>
                                ) : (

                                    <button type="submit" className="submit-btn btn-sm btn">
                                        Submit
                                    </button>
                                )}
                            </div>
                        </Form>
                    </FormikProvider>
                </div>
            </div >



        </>
    );
}